<template>
  <section :class="blockClass">
    <div class="container">
      <div class="row">
        <div class="col-12 typography">
          <h2 class="challenges-solutions__title" v-html="data.title"></h2>
        </div>
      </div>
    </div>
    <div class="challenges-solutions__main">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4 challenges-solutions__wheel">
            <p v-for="(theme, index) in data.themes" :key="'theme_' + index">
              <a @click.prevent="active_item_index = index">{{
                theme.content_title
              }}</a>
            </p>
          </div>
          <div class="col-12 col-md-8">
            <div
              class="col-12 col-md-8 challenges-solutions__content typography"
            >
              <p class="challenges-solutions__content__title">
                {{ activeItem.content_title }}
              </p>
              <div
                class="challenges-solutions__content__copy"
                v-html="activeItem.content_copy"
              ></div>
            </div>

            <table
              class="challenges-solutions__table typography table table-responsive"
            >
              <thead class="challenges-solutions__table__head">
                <tr>
                  <th>Challenge</th>
                  <th>Solution</th>
                  <th>Services</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in activeItem.challenges_and_solutions"
                  :key="index"
                >
                  <td class="challenges-solutions__table__challenge">
                    <p class="large">
                      {{ item.challenge }}
                    </p>
                  </td>
                  <td class="challenges-solutions__table__solution">
                    <p>{{ item.solution }}</p>
                  </td>
                  <td class="challenges-solutions__table__services">
                    <p
                      v-for="(service, service_index) in item.services"
                      :key="`service` + service_index"
                    >
                      <a :href="service.link.url" :title="service.link.title">
                        {{ service.link.title }}
                      </a>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ChallengesAndSolutionsWheel",
  data: function() {
    return {
      data: window.challenges_and_solutions_wheel,
      active_item_index: 0
    };
  },
  computed: {
    blockClass() {
      let blockClass = "challenges-solutions";
      if (this.data.background_colour) {
        blockClass += " block--background-" + this.data.background_colour;
      }
      return blockClass;
    },
    activeItem() {
      return this.data.themes[this.active_item_index];
    }
  }
};
</script>

<style scoped lang="scss">
.challenges-solutions {
  padding: 0 0 37px;

  &.block--background-grey {
    background-color: white;

    .challenges-solutions__main {
      background-color: #f5f5f5;
    }
  }

  &__main {
    background: {
      image: url("../../../images/challenges_solutions_bg.svg");
      position: left -10px;
      repeat: no-repeat;
    }
  }

  &__title {
    padding-bottom: 51px;
  }

  &__wheel {
    margin-top: -19px;
    width: 100%;
  }

  &__content {
    padding: 67px 0 29px;

    &__title {
      font-size: 20px;
      line-height: 22px;
      text-transform: uppercase;
      font-weight: 600;
      letter-spacing: 100/1000 * 16px;
    }

    &__copy {
      font-size: 14px;
      line-height: 20px;
      color: #646464;
    }
  }

  &__table {
    margin-bottom: 67px;
    color: #323232;

    td,
    th {
      border: 0;
      padding: 0;
    }

    &__head {
      th {
        text-transform: uppercase;
        font-size: 12px;
        letter-spacing: 120/1000 * 16px;
        padding-bottom: 16px;
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #dcdcdc;

        &:last-child {
          border: 0;
        }

        &:first-child {
          td {
            padding-top: 0;
          }
        }

        td {
          padding: 18px 0;
        }
      }
    }

    &__challenge {
      width: 40%;
      padding-right: 56px !important;
    }

    &__solution {
      width: 40%;
      padding-right: 56px !important;
      line-height: 20px;
      font-size: 14px;
    }

    &__services {
      width: 20%;

      p {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
